export default "__VITE_ASSET__173f4007__"